import { CSSProperties } from 'react';
import { Color, Size } from '@vivli/shared/theme';

export const cardContainerStyle: CSSProperties = {
    display: 'grid',
    width: '100%',
    height: '100%',
    backgroundColor: Color.CARD_LIGHT_BLUE,
    borderTop: '2px solid rgb(176, 176, 176)',
    padding: Size.PADDING,
    gap: '8px 0',
};

export const emptyDataStyle: CSSProperties = {
    display: 'grid',
    width: '100%',
    gridTemplateRows: '1fr 1fr',
    gridTemplateColumns: '1fr',
    alignItems: 'center',
    justifyItems: 'center',
    backgroundColor: Color.TRANSPARENT,
    padding: Size.PADDING,
    gap: '8px 0',
};

export const upperSectionStyle: CSSProperties = {
    display: 'grid',
    backgroundColor: Color.CARD_LIGHT_BLUE,
    gridTemplateColumns: '130px 1fr auto',
    alignItems: 'center',
    gap: '0 16px',
};

export const lowerSectionStyle: CSSProperties = {
    display: 'grid',
    backgroundColor: Color.CARD_LIGHT_BLUE,
    borderTop: '1px solid rgba(0,149,199,0.22)',
    gridTemplateColumns: '130px 1fr 1fr 1fr',
    alignItems: 'center',
    gap: '0 16px',
};

export const gridDataStyle: CSSProperties = {
    display: 'grid',
    minWidth: '1300px',
    width: '100%',
    height: '100%',
    gridTemplateRows: 'auto',
    gridTemplateColumns: '1fr',
    justifyContent: 'left',
    marginLeft: 'auto',
    backgroundColor: Color.TRANSPARENT,
};
